import { ReactNode } from 'react';
import classNames from 'classnames';

import createStyleVariables from 'utils/createStyleVariables';

import classes from './Truncate.module.scss';

type Props = {
  children: ReactNode;
  fluid?: boolean;
  maxWidth?: number | string;
  title?: string;
  ellipsisLines?: number;
  customConfig?: boolean;
};

const getTruncateMaxWidth = ({ fluid, maxWidth }: Pick<Props, 'fluid' | 'maxWidth'>): string => {
  if (fluid) {
    return '100%';
  }

  if (maxWidth) {
    return `${maxWidth}px`;
  }

  return 'auto';
};

const Truncate = ({ children, fluid, maxWidth, title, ellipsisLines, customConfig }: Props): JSX.Element => (
  <div
    className={classNames(classes.wrapper, { [classes.ellipsis]: ellipsisLines || customConfig })}
    title={title}
    style={
      !customConfig
        ? createStyleVariables({
            truncateMaxWidth: getTruncateMaxWidth({ fluid, maxWidth }),
            whiteSpace: ellipsisLines ? 'normal' : 'nowrap',
            ellipsisLines,
          })
        : undefined
    }
  >
    {children}
  </div>
);

export default Truncate;
